export default "__VITE_ASSET__CH7WcIPe__";